module.exports = __webpack_public_path__ + "static/logo_enlist-2fc336a16bfba31338f90875036a0246.svg";